import type { ScrapeByUrlResponse } from "@sidegigllc/api/client";

interface NamedOption {
  id: number;
  name: string;
}

/** Form fields the scrape response can populate. Only present keys are applied. */
export interface PopulatedJobFields {
  position?: number;
  name?: string;
  wage?: number;
  description?: string;
  job_type_id?: number;
  experience_level_id?: number;
}

/**
 * Maps a scrape-by-url response onto job form fields. Free-text `job_type` /
 * `experience_level` are matched case-insensitively against the loaded options;
 * an unmatched (or empty) value is simply omitted so it can't clear a field.
 */
export const mapScrapeResponseToJobFields = (
  data: ScrapeByUrlResponse,
  contractTypes: ReadonlyArray<NamedOption> | undefined,
  experienceLevels: ReadonlyArray<NamedOption> | undefined,
): PopulatedJobFields => {
  const fields: PopulatedJobFields = {};

  if (data.position_type?.id != null) fields.position = data.position_type.id;
  if (data.job_title) fields.name = data.job_title;

  const wage = data.wage != null ? Number(data.wage) : Number.NaN;
  if (!Number.isNaN(wage)) fields.wage = wage;

  if (data.description) fields.description = data.description;

  const jobType = data.job_type?.toLowerCase();
  const matchedJobType = jobType ? contractTypes?.find((c) => c.name.toLowerCase() === jobType) : undefined;
  if (matchedJobType) fields.job_type_id = matchedJobType.id;

  const level = data.experience_level?.toLowerCase();
  const matchedLevel = level ? experienceLevels?.find((l) => l.name.toLowerCase() === level) : undefined;
  if (matchedLevel) fields.experience_level_id = matchedLevel.id;

  return fields;
};
